export class UserRole extends Object {
    public static ROLE_ADMIN = 'admin';
    public static ROLE_ACCOUNTANT  = 'accountant';
    public static ROLE_DRIVER = 'driver';
    public static ROLE_STORAGE_MANAGER = 'storage-manager';
    public static ROLE_MANAGER = 'manager';
    public static ROLE_ADMIN_ID = 1;
    public static ROLE_ACCOUNTANT_ID  = 5;
    public static ROLE_DRIVER_ID = 2;
    public static ROLE_STORAGE_MANAGER_ID = 3;
    public static ROLE_MANAGER_ID = 4;

    id: number;
    name = '';
}



// WEBPACK FOOTER //
// /app/src/model/Entities/UserRole.ts